import { Container, Row, Col } from 'react-bootstrap';
import DOMPurify from 'dompurify';
import { AboutUs } from '../models/models';
import { removeInlineStyles } from '../services/htmlUtils';

interface AboutUsSectionProps {
  data?: AboutUs;
}

export const AboutUsSection = ({ data }: AboutUsSectionProps) => {

  return (
    <Container id="about" fluid="true">
      <Container>
        <Row>
          <Col lg={8}>
            <div className="py-5 pe-lg-4">
                <h2 id="about_us">About us</h2>
              {data?.text && <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(removeInlineStyles(data.text)) }} />}
            </div>
          </Col>
          <Col lg={4} className="bg-light">
            <div className="py-5 ps-lg-4">
              {data?.managers.map((manager, index) => (
                <div key={index}>
                  <h3 className="h5">{manager.title}</h3>
                  <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(removeInlineStyles(manager.text)) }} />
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};
